export const getRouteTitle = (pathname: string) => {
  switch (pathname) {
    case '/target-profiles/accounts':
      return 'Target Accounts';
    case '/target-profiles/contacts':
      return 'Target Contacts';
    case '/target-profiles/list':
      return 'List view';
    case 'admin-dashboard':
      return 'Admin Dashboard';
    case '/run-campaign':
      return 'Campaign';
    case '/resend-invitation':
      return 'Resend Invitation';
    case '/features':
      return 'Features';
    case '/icp/create':
      return 'Create ICP';
    case '/icp/update':
      return 'Update ICP';
    case '/icp/clone':
      return 'Clone ICP';
    case '/settings/account':
      return 'Account Settings';
    case '/settings/users':
      return 'Manage Users';
    case '/settings/config/intent-topics':
      return 'Intent';
    case '/settings/config/icp':
      return 'Ideal Customer Profile';
    case '/settings/config/exclusion-list':
      return 'Exclusion List';
    case '/settings/config/custom-fields':
      return 'Custom Fields';
    case '/exclusion-list/import':
      return 'Exclusion List Import';
    case '/settings/config/web-tracking':
      return 'Website Tracking Configuration';
    case '/database-search/accounts':
      return 'Database Search';
    case '/database-search/contacts':
      return 'Database Search';
    case '/website/visitors':
      return 'Website Visit Accounts';
    case '/website/overview':
      return 'Website Visit Accounts';
    case '/website/webpages':
      return 'Website Visit Accounts';
    case '/login':
      return 'Login to Sprouts ABM';
    case '/forgot-password':
      return 'Forgot Password';
    case 'settings/agent-setup/website-agent/basic-setup':
      return 'Basic Setup';
    case 'settings/agent-setup/website-agent/target-setup':
      return 'Target Setup';
    case 'settings/agent-setup/website-agent/sprouts-signals':
      return 'Sprouts Signals';
    case 'settings/agent-setup/website-agent/knowledge-base':
      return 'Knowledge Base';
    case 'settings/agent-setup/website-agent/conversation-setup':
      return 'Conversation Setup';
    default:
      return 'Sprouts-ABM';
  }
};
